import { Button, Flex, Grid, Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import type { TabFilters as TabFiltersType } from "../types";

import s from "./TabFilters.module.css";

const { useBreakpoint } = Grid;

const TabFilters = ({
  type = "inclusive",
  filters,
  onChange,
  defaultValue = [],
  onResetAll,
  updateQuery,
  resetQuery,
}: TabFiltersType) => {
  const { t } = useTranslation(["common"]);
  const screens = useBreakpoint();
  const [activeFilters, setActiveFilters] = useState<string[]>(defaultValue);

  const isSelectAll = (value: string) => {
    const f = filters.find(f => f.value === value);
    return f?.isSelectAll || false;
  };

  useEffect(() => {
    setActiveFilters(defaultValue);
  }, [defaultValue]);

  const handleSelectFilter = (value: string) => {
    const isAll = isSelectAll(value);

    let newFilters: string[] = [];

    if (isAll || type === "exclusive") {
      newFilters = [value];
    } else {
      const cleanedFilters = activeFilters.filter(f => !isSelectAll(f));
      newFilters = cleanedFilters.includes(value)
        ? cleanedFilters.filter(f => f !== value)
        : [...cleanedFilters, value];
    }

    setActiveFilters(newFilters);
    onChange(isAll ? [] : newFilters);
    updateQuery?.(isAll ? [] : newFilters);
  };

  const handleResetAll = () => {
    const selectAll = filters.find(filter => filter.isSelectAll);
    setActiveFilters([selectAll?.value ?? ""]);
    onResetAll();
    resetQuery?.();
  };

  return (
    <Flex justify="space-between" align="center" className={s.container}>
      <Space.Compact orientation={screens.sm ? "horizontal" : "vertical"}>
        {filters.map(filter => (
          <Button
            data-testid={filter.testId}
            key={filter.value}
            type={activeFilters.includes(filter.value) ? "primary" : "default"}
            onClick={() => handleSelectFilter(filter.value)}
          >
            {filter.label}
          </Button>
        ))}
      </Space.Compact>
      <Button
        data-testid="products-reset-all-filters"
        type="link"
        onClick={handleResetAll}
      >
        {t("common:components.buttons.resetAll")}
      </Button>
    </Flex>
  );
};

export default TabFilters;
